import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface IDeveloperPlatformState {
  // the open buttons live in the toolbar and the dialogs in their panels
  isAddCredentialOpen: boolean;
  isAddEndpointOpen: boolean;
}

export const initialState: IDeveloperPlatformState = {
  isAddCredentialOpen: false,
  isAddEndpointOpen: false,
};

export const developerPlatformSlice = createSlice({
  name: 'developerPlatform',
  initialState,
  reducers: {
    setAddCredentialOpen: (state, action: PayloadAction<boolean>) => {
      state.isAddCredentialOpen = action.payload;
    },
    setAddEndpointOpen: (state, action: PayloadAction<boolean>) => {
      state.isAddEndpointOpen = action.payload;
    },
  },
});

export const { setAddCredentialOpen, setAddEndpointOpen } =
  developerPlatformSlice.actions;
